// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"e631855af83866180192","966":"fe07824c1b902e12cdf0"}[chunkId] + ".js";
};